!function(window) {
$(document).ready(function () {
	
	if(document.getElementById('beneciaMap')){
		
		const redIcon = L.icon({
			iconUrl: '/images/svg/mapPin.svg',
			iconSize:     [30, 43], // size of the icon
			iconAnchor:   [15, 43], // point of the icon which will correspond to marker's location
			popupAnchor:  [0, -43]  // point from which the popup should open relative to the iconAnchor
		});
		
		var layerGroup;
		var map;
		var allMarkers = {};
		var marker;
		//let oms;
		
		const northBound = 46.6;
		const southBound = 45.5;
		const eastBound = 14.16;
		const westBound = 12.75;
		
		var boundsFixed = [
			[northBound, westBound],
			[northBound, eastBound],
			[southBound, eastBound],
			[southBound, westBound]
		];
		
		function initMapLeaflet() {
			map = L.map('beneciaMap', {
				center: [ 46.1936180, 13.47110811 ],
				maxBoundsViscosity: 1, // fully solid bounds
				zoom: 11,
				maxZoom: 15,
				minZoom: 8,
				zoomControl: true,
				scrollWheelZoom: false,
				//dragging: true,
				dragging: !L.Browser.mobile,
				tap: !L.Browser.mobile
			});
			map.attributionControl.setPrefix('<a href="https://leafletjs.com" title="Leaflet - a JavaScript library for interactive maps" rel="noopener external" target="_blank">Leaflet</a>')
			map.zoomControl.setPosition('bottomright');
			
			var Esri_WorldTopoMap = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
				attribution: 'Tiles &copy; Esri'
			})
			
			Esri_WorldTopoMap.addTo(map)
			
			layerGroup = L.layerGroup().addTo(map); //layer group for markers on map
			//oms = new OverlappingMarkerSpiderfier(map, {keepSpiderfied: true, nearbyDistance: 15, circleSpiralSwitchover: 9, legWeight: 2, } );
			//oms.legColors.usual = "#222222";
			//oms.legColors.highlighted = "#222222";
		}
		
		function clearMarkerSelected(){
			map.closePopup();
			$('.oneProject').removeClass('hover');
			for(var key in allMarkers){
				allMarkers[key].setIcon(redIcon);
			}
		}
		
		const regexLat = /^(-?[1-8]?\d(?:\.\d{1,18})?|90(?:\.0{1,18})?)$/;
		const regexLon = /^(-?(?:1[0-7]|[1-9])?\d(?:\.\d{1,18})?|180(?:\.0{1,18})?)$/;
		
		function check_lat_lon(lat, lon) {
			
			const validLat = regexLat.test(lat) && parseFloat(lat) > southBound && parseFloat(lat) < northBound;
			const validLon = regexLon.test(lon) && parseFloat(lon) > westBound && parseFloat(lon) < eastBound;
			
			return validLat && validLon;
		}
		
		function markersMap() {
			layerGroup.clearLayers();
			//oms.unspiderfy();
			
			var bounds = [];
			var mapData = document.getElementsByClassName("mapItemData");
			var iAdd = 0;
			
			for (let i = 0; i < mapData.length; i++) {
				
				const lat = $(mapData[i]).data('lat');
				const lon = $(mapData[i]).data('lon');
				if(lat && lon && check_lat_lon(lat, lon)){
					
					var position = [lat, lon];
					var titleUrl = '<a href="'+ $(mapData[i]).data('url') +'">'+  $(mapData[i]).data('title') +'</a>';
					marker = L.marker(position, {icon: redIcon, idMarkerja:$(mapData[i]).data('id'), imeMarkerja:$(mapData[i]).data('title'), urlMarkerja:$(mapData[i]).data('url') }); // marker gets custom fields for id and location name
					
					marker.bindPopup(titleUrl);
					marker.addTo(layerGroup);
					//oms.addMarker(marker);
					bounds.push(position);
					
					if(allMarkers[marker.options.idMarkerja]){
						allMarkers[marker.options.idMarkerja+'_add'+iAdd] = marker;
						iAdd++;
					}else{
						allMarkers[marker.options.idMarkerja] = marker;
					}
					
					marker.on('mouseover', function (e) {
						clearMarkerSelected();
						if(typeof this.options.idMarkerja !== 'undefined'){
							
						}
						this.openPopup();
					});
					
					marker.on('click', function (e) {
						if(e.target.options.urlMarkerja != undefined && e.target.options.urlMarkerja !== ''){
							window.location.href = e.target.options.urlMarkerja
						}else{
							e.target.openPopup();
						}
					});
				}else{
					//console.log("Error in coordinates for ID: "+$(mapData[i]).data('id'));
				}
			}
			map.addLayer(layerGroup);
			if(bounds.length != 0 ){
				map.fitBounds(bounds, {padding: [15, 15]}); // fits map zoom to show all markers
			}
		}
		
		initMapLeaflet();
		markersMap();
		
		map.setMaxBounds(boundsFixed);
		
		map.on('drag', function() {
			map.panInsideBounds(boundsFixed, { animate: false });
		});
		
		
		const buttonSelector = '.filterMapButton';
		$(buttonSelector).on('click', function(e){
			e.preventDefault();
			
			var category = null;
			if($(this).hasClass('active')){
				$(buttonSelector).removeClass('active');
			}else{
				$(buttonSelector).removeClass('active');
				$(this).addClass('active');
				category = $(this).attr('id')
			}
			
			getResultsMapPoi(category);
		});
		
		$('.filterMapAreas select').on('change', function(e){
			e.preventDefault();
			getResultsMapPoi();
		});
		
		function getResultsMapPoi(category = null) {
			$('#beneciaMap').addClass('opacity-loading').trigger('classChangeLoading');
			
			const func = $('#filterMenu').attr('data-func');
			const strid = $('#body-content').attr('data-strid');
			const areaId = $('#area').val();
			
			var params = {func: func, map:'', str: strid };
			if( areaId ){
				params['area'] = areaId;
			}
			
			category = category != null ? category : $(buttonSelector+'.active').attr('id');
			if(category){
				params['category'] = category;
			}
			
			getFilterResults(params, ['func', 'str'], function( jqueryHtml ){
				$('#mapData').empty();
				$('#mapData').append(jqueryHtml);
				markersMap();
				$('#beneciaMap').removeClass('opacity-loading');
				$('#listLink').attr('href', '?'+( params['area'] ? '&area='+params['area'] : '')+( params['category'] ? '&category='+params['category'] : ''));
			});
		}
		
	}
});

}.call(window, window);